import * as tslib_1 from "tslib";
import { SearchesCommon } from '../searches.common';
var SearchesOwnNameComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SearchesOwnNameComponent, _super);
    function SearchesOwnNameComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isActive = 'sublistName';
        _this.displayedColumns = [
            'checkbox',
            'fullName',
            'idNumber',
            'sublistName',
            'country',
            'uniqueReferenceCode',
            'dateDetail',
            'comment',
            'matched'
        ];
        return _this;
    }
    return SearchesOwnNameComponent;
}(SearchesCommon));
export { SearchesOwnNameComponent };
